import createEventEmitter from 'utils/create-event-emitter';

export const fileUploadEmitter = createEventEmitter();
